module.exports = __webpack_public_path__ + "img/Bank.b66a97ca.svg";